<ng-container *ngIf="{ expiracionClave: expiracionClave$ | async, ready: ready$ | async } as data">

	<div @smoothShow *ngIf="data.expiracionClave?.darAviso" class="container">
		<div class="message__container">
			<vencimiento-clave></vencimiento-clave>
			<div>Modificá tu contraseña para mantener el ingreso a Comunità.</div>
			<div class="options">
				<button *ngIf="data.expiracionClave.puedePosponer" [disabled]="!data.ready" class="btn" (click)="onRecordarMasTarde()" gtagEvent="posponer-aviso" gtagCategory="expiración-contraseña">Recordármelo más tarde</button>
				<button [disabled]="!data.ready" class="btn cambiar" routerLink="/perfil/cambio-clave" gtagEvent="modificar-contraseña" gtagCategory="expiración-contraseña">Modificar contraseña</button>
			</div>
		</div>
	</div>

</ng-container>
